import { FormEvent, FormEventHandler } from 'react';
import { Form, TextField, validators } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import styles from './index.module.scss';

const EditableAddress = ({
  handleSubmit,
  handleChange,
}: {
  handleSubmit: FormEventHandler<HTMLFormElement>;
  handleChange: (event: FormEvent<HTMLInputElement>, field: string) => void;
}) => {
  const { t } = useTranslation('Disconnect', { keyPrefix: 'contactInfo' });

  const getValidationRules = (fieldName: string) => [
    validators.required({ message: t('requiredField', { fieldName }) }),
  ];

  return (
    <Form
      id="address-form"
      validationMode="onSubmit"
      onSubmit={handleSubmit}
      className={styles['editAddressForm']}
    >
      <div className={styles['editAddressFormGroup']}>
        <TextField
          required
          validationRules={getValidationRules(t('shippingAddress.street'))}
          fluid
          id="streetAddress"
          name="streetAddress"
          labelProps={{ labelText: t('shippingAddress.street') }}
          onChange={(e) => handleChange(e, 'streetAddress')}
        />
        <TextField
          fluid
          id="apt"
          name="apt"
          labelProps={{ labelText: t('shippingAddress.apt') }}
          onChange={(e) => handleChange(e, 'apt')}
        />
      </div>
      <div className={styles['editAddressFormGroup']}>
        <TextField
          required
          validationRules={getValidationRules(t('shippingAddress.city'))}
          fluid
          id="city"
          name="city"
          labelProps={{ labelText: t('shippingAddress.city') }}
          onChange={(e) => handleChange(e, 'city')}
        />
        <TextField
          required
          validationRules={getValidationRules(t('shippingAddress.state'))}
          fluid
          id="state"
          name="state"
          labelProps={{ labelText: t('shippingAddress.state') }}
          onChange={(e) => handleChange(e, 'state')}
        />
        <TextField
          required
          validationRules={getValidationRules(t('shippingAddress.postalCode'))}
          fluid
          id="postalCode"
          name="postalCode"
          labelProps={{ labelText: t('shippingAddress.postalCode') }}
          onChange={(e) => handleChange(e, 'postalCode')}
        />
      </div>
    </Form>
  );
};

export default EditableAddress;
